import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {SwalComponent} from '@sweetalert2/ngx-sweetalert2';
import {Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import {AutomatKindService} from '../services/automat-kind.service';
import {AutomatKind} from '../models/automatKind';

@Component({
  selector: 'app-automat-kind',
  templateUrl: './automat-kind.component.html',
  styleUrls: ['./automat-kind.component.css']
})
export class AutomatKindComponent implements OnInit {

  @ViewChild('closeCreateModal') closeCreateModal: ElementRef;
  @ViewChild('closeUpdateModal') closeUpdateModal: ElementRef;
  @ViewChild('errorSwal') private errorSwal: SwalComponent;
  @ViewChild('successSwal') private successSwal: SwalComponent;

  public searchText;
  public automatKinds: [AutomatKind];
  public automatKind: AutomatKind;
  public selectedId;
  public selectedKind;
  public errorMessage = '';
  constructor(private kindService: AutomatKindService,
              private router: Router,
              private spinner: NgxSpinnerService) {
  }

  ngOnInit() {
    this.getAutomatKinds();
    this.clearAutomatKind();
  }


  createAutomatKind() {
    if (!this.checkIsFieldsOkay())  { return ; }
    if (this.isExist(this.automatKind.name, 0)) { return; }
    this.kindService.createAutomatKind(this.automatKind).subscribe(response => {
      this.spinner.hide();
      this.successSwal.text = 'Otomat türü başarıyla oluşturuldu!';
      this.successSwal.show();
      this.closeCreateModal.nativeElement.click();
      this.getAutomatKinds();
    }, error => {
      this.spinner.hide();
      this.errorSwal.text = 'Otomat türü oluşturulurken hata oluştu!';
      this.errorSwal.show();
    });
    this.clearAutomatKind();
  }
  getAutomatKinds() {
    this.kindService.getAutomatKinds().subscribe(res => {
      this.automatKinds = res.result;
    }, error => {
      if (error.message === 'Error: Access Denied') {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        this.router.navigate(['/login']);
      } else {
        this.errorSwal.title = error.status;
        this.errorSwal.text = error.error;
        this.errorSwal.show();
        console.log('Error:', error);
      }
    });
  }

  deleteAutomatKind(id) {
    if (id === '' || id === undefined) {
      this.errorSwal.title = 'Kind id alınamadı!';
      this.errorSwal.show();
      return;
    }
    this.spinner.show();
    this.kindService.deleteAutomatKind(id).subscribe(res => {
      this.successSwal.title = 'Başarılı!';
      this.successSwal.show();
      this.getAutomatKinds();
      this.spinner.hide();
    }, error => {
      if (error.message === 'Error: Access Denied') {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        this.router.navigate(['/login']);
        this.spinner.hide();
      } else {
        this.errorSwal.title = error.status;
        this.errorSwal.text = error.error;
        this.errorSwal.show();
        this.spinner.hide();
      }
    });
  }

  updateAutomatKind() {
    if (!this.checkIsFieldsOkay()) {  return; }
    if (this.isExist(this.automatKind.name, this.automatKind._id)) { return; }
    this.spinner.show();
    this.kindService.updateAutomatKind(this.automatKind, this.automatKind._id).subscribe(res => {
      this.successSwal.title = 'Başarılı!';
      this.successSwal.show();
      this.closeUpdateModal.nativeElement.click();
      this.getAutomatKinds();
      this.clearAutomatKind();
      this.spinner.hide();
    }, error => {
      if (error.message === 'Error: Access Denied') {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        this.router.navigate(['/login']);
        this.spinner.hide();
      } else {
        this.errorSwal.title = error.status;
        this.errorSwal.text = error.error;
        this.errorSwal.show();
        this.spinner.hide();
      }
    });
  }

  selected(kind) {
    this.clearAutomatKind();
    this.automatKind = Object.assign({}, kind);
  }
  isExist(name, id) {
    const result =  this.automatKinds.some(x =>  x.name.toLowerCase() === name.toLowerCase() && x._id !== id);
    if (result) {
      this.errorMessage = 'Bu isimli bir otomat türü mevcuttur!';
      this.spinner.hide();
    }
    return result;
  }
  clearAutomatKind() {
    this.automatKind = new AutomatKind();
    this.automatKind.indexKey = 0;
    this.errorMessage = '';

  }
  checkIsFieldsOkay(): boolean {
    let isOkay = true;
    if (this.automatKind.name === '' || this.automatKind.name === undefined) { isOkay = false; }
    if (this.automatKind.description === '' || this.automatKind.description === undefined) { isOkay = false; }
    // tslint:disable-next-line:max-line-length
    if (this.automatKind.column <= 0 || this.automatKind.productCount <= 0 || this.automatKind.row <= 0 || this.automatKind.capacity <= 0) { isOkay = false; }
    if (!isOkay) {
      this.errorSwal.text = 'Lütfen tüm alanları doldurunuz ve negatif değerler girmeyiniz!';
      this.errorSwal.show();
      return false;
    } else {
      return true;
    }
  }
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/automat-kind/automat-kind.component.ts